<template>
  <div class="[ flex flex-col min-h-screen ]">
    <router-view />
  </div>
</template>

<script setup lang="ts">
definePage({
  meta: {
    title: "Logged Out",
    public: true,
  },
});
</script>
